import { DatePipe, isPlatformBrowser, NgOptimizedImage, CommonModule, DOCUMENT } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA, Component, ElementRef, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild, Renderer2,
  ChangeDetectorRef, AfterContentChecked, AfterViewChecked, OnChanges, viewChild, AfterViewInit, ChangeDetectionStrategy,
  afterNextRender, effect
} from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavigationEnd, Router, RouterModule, ActivatedRoute } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { DatepickerDateCustomClasses, BsDatepickerDirective, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import * as globalConstant from '../../global_constant';
import { Subscription } from 'rxjs';
import { Meta, Title } from '@angular/platform-browser';
import { MainService } from '../../main.service';
import { MessageService } from '../../message.service';
import { ToastrService } from '../../services/toastr.service';
import { LocationService } from '../../services/location.service';
import { FindCouple } from '../../services/findcouple.service';
import { VisitorsService } from '../../services/Visitors.service';
import { Experience } from '../../services/experience.service';
import { PageSectionService } from '../../services/PageSection.service';
import { AutoCompleteModule, AutoComplete } from 'primeng/autocomplete';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgZone } from '@angular/core';
import { CanonicalService } from 'src/app/services/canonical.service';
import { CmsPageSeoService } from 'src/app/services/cms-page-seo.service';
import { GalleriaModule, Galleria } from 'primeng/galleria';
import { ReferralCodeService } from 'src/app/services/ReferralCode.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { PriceFormat } from '../../priceFormat.pipe';

/** Survives SPA navigations when the homepage component is destroyed/recreated. */
let popularExperiencesMemoryCache: any[] | null = null;

@Component({
  selector: 'app-homepage-new',
  imports: [
    AutoCompleteModule,
    NgxSkeletonLoaderModule,
    GalleriaModule,
    NgOptimizedImage,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    BsDatepickerModule,
    PriceFormat,
  ],
  templateUrl: './homepage-new.html',
  styleUrl: './homepage-new.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomepageNew implements OnInit, OnDestroy, AfterViewInit, OnChanges {
  @ViewChild('videoElement', { static: false }) videoElement: ElementRef;
  mobBannerView: any = "";
  is_mobile_view: boolean = false;
  mobileViewScreen: boolean = false;
  private _picker: BsDatepickerDirective;
  loading = false;
  isBrowser: boolean;
  section_data: any;
  spurExperience: any = {};
  section_image_url = '';
  authUser: any;
  base_website_url: string = '';
  wedding_registry_background: any = ''
  circleData: any = {};
  influencerSecton: any = {};
  providerSection: any = {};
  spurfectRewardsSection: any = null;
  spurfectRewardsTitleLead = '';
  spurfectRewardsTitleAccent = '';
  spurfectRewardsDescriptionHtml = '';
  wedding_registry: any = {}
  popularDestinations: any = [];
  popularCategories: any = [];
  popularExperiences: any = [];
  /** Remount trending swiper after SPA restore so slides paint. */
  trendingSwiperVisible = false;
  autocompleteExpResults: any = [];
  autocompleteCoupleResults: any = [];
  autocompleteCategoryResults: any = []
  tokenkey: any = '';
  see_world_section: any = {};
  download_app_section: any = {}
  ipAddress: any;
  ip_location: any;
  iplocation: any;
  home_experience: any;
  date_value: any = '';
  minDate = new Date();
  maxDate: Date
  nowTime: Date
  latitude: number;
  longitude: number;
  dateCustomClasses: DatepickerDateCustomClasses[];
  location: any = 0
  timePipeString: string;
  datePipeString: string;
  SubscribeForm: FormGroup;
  submitted = false;
  certificate_data: any = '';
  clickCart: any = '';
  subscribe_error_message: any = '';
  subscribe_error = false;
  home_exp_length: any = '';
  home_slider: any = '';
  exp_slug: any = '';
  couple_slug: any = '';
  category_slug: any = ''
  country_List: any = [];
  state_List: any = [];
  nearBySearch: any = {}
  country_id: any = globalConstant?.default_country;
  tikTokUrl: any = globalConstant?.OWNER_TIK_TOK_URL;
  instagramUrl: any = globalConstant?.OWNER_INSTAGRAM_URL;
  enable_rfp_224: any = globalConstant?.ENABLE_RFP_224;
  web_cdn_url: String = globalConstant?.WEB_CDN_URL;
  subscription: Subscription;
  home_gift_card: any = [];
  gift_data_first_name: any;
  gift_data_second_name: any;
  isLive: any = globalConstant?.IS_LIVE;
  home_mobile_banner: any;
  mobBannerImage: string = "";
  banner_video: any = ''
  autocompleteLocationResults: any = [];
  location_booking: any = "";
  categoryList: any = [];
  mobBannerVideo: string = "";
  exp_image_url: string = '';
  location_image_url: string = '';
  category_image_url: string = '';
  autocomplete_search: string;
  autocomplete_search_to: any
  autocomplete_couple_search: string
  results: string[];
  autocomplete_location_search: string = "";
  location_id: Number = 0;
  exp_title_search: string;
  page_data: any;
  searchExp: any
  gift_experiences_data: any = {}
  guest_about_spur: any = {}
  home_url: string = globalConstant?.WEBSITE_URL;
  static EMAIL: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  selectedDate: any;
  selectedDateRange: any
  searchHistory: any[] = [];
  continuePlanningData: any[] = [];
  /** Display lists — always kept in sync by syncPlanningNearbySection(). */
  nearbyExperiencesPreview: any[] = [];
  continuePlanningPreview: any[] = [];
  /** Client-only flag so SSR doesn't paint nearby-only DOM that later becomes 6|3. */
  planningNearbyReady = false;
  /** desktop ≥1100px (same row), tablet 768–1099px (stacked), mobile <768px (sliders). */
  planningNearbyMode: 'desktop' | 'tablet' | 'mobile' = 'desktop';
  showNearbyBrowseAll = false;
  isCookies: boolean;
  showRecentSearches: boolean = false;
  /** Set on pointerdown so we don't open recent searches from initial/autofocus. */
  private searchBoxPointerActivated = false;
  isOpenDatePicker: any = false
  isOpenDatePickerMobile: any = false
  address: string;
  city: string;
  selectedNearby: any = false;
  anyPrice: string = "Any Price";
  isBoat: boolean;
  siteUrl: String = globalConstant?.WEBSITE_URL;
  pageUrl: any = '';
  /** False until home pageData resolver payload is applied (avoids empty SSR flash). */
  isPageReady = false;


  seasonalPromotionsData: any;
  images: any[] | undefined;
  /** Derived hero mode — same admin rules: active promo images | promo video | default page video */
  bannerMode: 'seasonal-images' | 'seasonal-video' | 'default' = 'default';
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  @ViewChild('autoCompleteRef') autoComplete!: AutoComplete;
  enteredValue: string = "";
  activeIndex = 0;
  isSliderReady: boolean = false;

  readonly heroFeatures = [
    {
      title: 'Cash Back',
      description: 'To purchaser for 30 days from order.',
      icon: 'cash'
    },
    {
      title: 'Flexible Swaps',
      description: 'Swap one experience for another.',
      icon: 'swap'
    },
    {
      title: 'Never Expire',
      description: 'Vouchers never expire.',
      icon: 'calendar'
    },
    {
      title: 'Gifting Options',
      description: 'Purchase an E-gift or gift box.',
      icon: 'gift'
    }
  ];

  breakpoints = {
    0: {
      slidesPerView: 1,
      spaceBetween: 10
    },
    575: {
      slidesPerView: 2,
      spaceBetween: 10
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 30
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 30
    }
  };

  popularDestinationsBreakpoints = {
    0: {
      slidesPerView: 1.15,
      spaceBetween: 12
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 14
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 16
    },
    992: {
      slidesPerView: 4,
      spaceBetween: 16
    },
    1200: {
      slidesPerView: 6,
      spaceBetween: 18
    }
  };

  trendingExperiencesBreakpoints = {
    0: {
      slidesPerView: 1.15,
      spaceBetween: 12
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 14
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 16
    },
    992: {
      slidesPerView: 4,
      spaceBetween: 16
    },
    1200: {
      slidesPerView: 5,
      spaceBetween: 18
    }
  };

  reviewBreakpoints = {
    0: {
      slidesPerView: 1,
      spaceBetween: 16,
      centeredSlides: true
    },
    575: {
      slidesPerView: 1.15,
      spaceBetween: 18,
      centeredSlides: true
    },
    768: {
      slidesPerView: 2.15,
      spaceBetween: 22,
      centeredSlides: true
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 24,
      centeredSlides: true
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 28,
      centeredSlides: true
    }
  };

  testimonialAutoplay = {
    delay: 3500,
    disableOnInteraction: false,
    pauseOnMouseEnter: false
  };

  private testimonialSwiperReady = false;

  brandsBreakpoints = {
    0: {
      slidesPerView: 2,
      spaceBetween: 12
    },
    480: {
      slidesPerView: 4,
      spaceBetween: 14
    },
    768: {
      slidesPerView: 6,
      spaceBetween: 16
    },
    992: {
      slidesPerView: 7,
      spaceBetween: 18
    },
    1200: {
      slidesPerView: 8,
      spaceBetween: 20
    }
  };

  swiperEl = viewChild<ElementRef>('swiperEl');
  // @ViewChild('swiperEl', { static: false }) swiperEl!: ElementRef;
  swiperEl2 = viewChild<ElementRef>('swiperEl2');
  swiperEl3 = viewChild<ElementRef>('swiperEl3');
  swiperEl4 = viewChild<ElementRef>('swiperEl4');
  swiperEl5 = viewChild<ElementRef>('swiperEl5');
  swiperEl6 = viewChild<ElementRef>('swiperEl6');
  sectionData: any = [];
  brandLogos: any[] = [];
  scriptLoaded = false;
  isItemSelected = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private datePipe: DatePipe,
    private formBuilder: FormBuilder,
    private titleService: Title,
    private mainService: MainService,
    private messageService: MessageService,
    public toastr: ToastrService,
    public router: Router,
    public locationService: LocationService,
    private findCouple: FindCouple,
    private visitorService: VisitorsService,
    private experienceService: Experience,
    private pageSectionService: PageSectionService,
    private renderer: Renderer2,
    private metaService: Meta,
    private breakpointObserver: BreakpointObserver,
    private referralCodeService: ReferralCodeService,
    private cdref: ChangeDetectorRef,
    private canonicalService: CanonicalService,
    private cmsPageSeoService: CmsPageSeoService,
    private ngZone: NgZone,
    @Inject(PLATFORM_ID) platformId: Object,
    @Inject(DOCUMENT) private document: any,
  ) {
    this.subscription = new Subscription();
    let currenturl = this.router.url;
    let componentUrl = currenturl.startsWith('/') ? currenturl.slice(1) : currenturl;
    const canonicalUrl = this.normalizeUrl(this.siteUrl + componentUrl);
    this.pageUrl = this.canonicalService.setCanonical(canonicalUrl);
    this.setGlobalPassiveEvents();
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      this.restorePopularExperiencesFromCache(false);
      window.scrollTo(0, 0);
      this.isBoat = this.isSitePerformanceBoat();
      // After hydrate: read localStorage continue-planning and recompute the 6-card split.
      afterNextRender(() => {
        this.isCookies = this.getCookie('acceptCookies') !== '';
        this.loadContinuePlanningData();
        this.syncPlanningNearbySection();
        this.planningNearbyReady = true;
        // Ensure Where To? is not left focused/open from PrimeNG/browser autofocus.
        this.showRecentSearches = false;
        this.searchBoxPointerActivated = false;
        this.autoComplete?.inputEL?.nativeElement?.blur();
        this.autoComplete?.hide();
        // Remount trending swiper once the view exists (constructor only restored data).
        if (this.popularExperiences?.length) {
          this.persistPopularExperiences(this.popularExperiences);
          this.applyPopularExperiences([...this.popularExperiences]);
        } else {
          this.restorePopularExperiencesFromCache(true);
        }
        if ((this.images?.length || 0) > 1) {
          this.isSliderReady = true;
        }
        this.cdref.detectChanges();
      });

      // Testimonials live inside @defer — refresh Swiper once the element mounts
      // so desktop starts at 3 slides (not a stale 1/2 from a zero-width init).
      effect(() => {
        const ref = this.swiperEl5();
        if (ref?.nativeElement) {
          this.refreshTestimonialSwiper();
        }
      });

      // Trending experiences: re-init when the swiper mounts (session restore / SPA return).
      effect(() => {
        const ref = this.swiperEl4();
        if (ref?.nativeElement && this.popularExperiences?.length) {
          this.refreshTrendingExperiencesSwiper();
        }
      });
    }
    if (this.isBrowser) {
      this.subscription.add(
        this.breakpointObserver
          .observe(['(max-width: 767px)'])
          .subscribe(result => {
            this.is_mobile_view = result.matches;
            this.cdref.markForCheck();
          })
      );

      this.subscription.add(
        this.breakpointObserver
          .observe(['(max-width: 575px)'])
          .subscribe(result => {
            this.mobileViewScreen = result.matches;
            this.cdref.markForCheck();
          })
      );

      this.subscription.add(
        this.breakpointObserver
          .observe(['(max-width: 767.98px)', '(min-width: 1100px)'])
          .subscribe(result => {
            const mode = result.breakpoints['(max-width: 767.98px)']
              ? 'mobile'
              : result.breakpoints['(min-width: 1100px)'] ? 'desktop' : 'tablet';
            if (mode !== this.planningNearbyMode) {
              this.planningNearbyMode = mode;
              this.syncPlanningNearbySection();
            }
          })
      );
    }
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    if (this.isBrowser) {
      if (localStorage.getItem('login_token')) {
        this.tokenkey = localStorage.getItem('login_token');
      }
      if (localStorage.getItem('authUser')) {
        this.authUser = JSON.parse(localStorage.getItem('authUser'));
      }
    }
    this.subscription.add(
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          if (this.isBrowser) {
            document.querySelector("body").classList.remove("overflow");
          }
          this.cdref.markForCheck();
        }
      })
    );
    if (this.isBrowser) {

      if (localStorage.getItem('temporary_charity_gallery_url')) {
        localStorage.removeItem('temporary_charity_gallery_url');
      }
    }
    const now = new Date();
    this.dateCustomClasses = [
      { date: now, classes: ['bg-warning', 'text-white'] },
    ];

    this.nowTime = new Date();
    this.timePipeString = datePipe.transform(Date.now(), 'h:mm a');
    this.datePipeString = datePipe.transform(Date.now(), 'yyyy-MM-dd');
  }

  normalizeUrl(url: string): string {
    return url.endsWith('/') ? url.slice(0, -1) : url; // Remove trailing slash if present
  }

  isSitePerformanceBoat(): boolean {
    const userAgent = window.navigator.userAgent;
    if (userAgent.includes('GTmetrix') || userAgent.includes('Chrome-Lighthouse')) {
      return true;
    }
    return false;
  }

  autocompleteCoupleSearch(event) {
    this.subscription.add(
      this.findCouple.find_couples(1, event?.query, this.tokenkey).subscribe(res => {
        if (res?.response == 'success') {
          this.autocompleteCoupleResults = res?.data?.data?.data;
        } else {
          this.autocompleteCoupleResults = [];
        }
        this.cdref.markForCheck();
      })
    );
  }

  autocompleteCategorySearch(event) {
    this.subscription.add(
      this.experienceService.experiencesCategory(event?.query).subscribe(res => {
        if (res?.response == 'success') {
          this.autocompleteCategoryResults = res?.data;
        } else {
          this.autocompleteCategoryResults = [];
        }
        this.cdref.markForCheck();
      })
    );
  }

  searchExpName() {
    this.router.navigate(['/shop'], { queryParams: { title: this.searchExp } });
  }
  onSelectAutocompleteSearch(event, isMobile) {
    this.isItemSelected = true; // prevent reopen

    this.autocomplete_search_to = event?.value;
    this.exp_slug = event?.value?.value.trim();

    // close dropdown manually
    this.autoComplete.hide();

    if (event?.value?.type == 'exp') {
      if (this.exp_slug) {
        if (isMobile) {
          this.router.navigateByUrl('/experiences/' + this.exp_slug).then(() => {
            if (this.isBrowser) window.location.reload();
          });
        } else {
          this.router.navigate(['/experiences/' + this.exp_slug]);
        }
      }
    } else {
      isMobile ? this.isOpenDatePickerMobile = true : this.isOpenDatePicker = true;
    }

    // reset flag after short delay
    setTimeout(() => {
      this.isItemSelected = false;
      this.cdref.markForCheck();
    }, 200);
    this.cdref.markForCheck();
  }

  onClickSearch() {
    this.router.navigate(['/shop'], { queryParams: { title: this.autocomplete_search } })
  }

  private normalizeCoord(value: any): number | null {
    if (value == null || value === '') {
      return null;
    }
    if (typeof value === 'function') {
      try {
        value = value();
      } catch {
        return null;
      }
    }
    const num = Number(value);
    return Number.isFinite(num) ? num : null;
  }

  private extractCityFromAddress(address: any): string {
    const components = address?.address_components;
    if (!components?.length) {
      return '';
    }
    let city = '';
    for (let i = 0; i < components.length; i++) {
      const types = components[i]?.types || [];
      if (types.includes('locality')) {
        return components[i]?.long_name || '';
      }
      if (!city && types.includes('administrative_area_level_3')) {
        city = components[i]?.long_name || '';
      } else if (!city && types.includes('administrative_area_level_2')) {
        city = components[i]?.long_name || '';
      }
    }
    return city;
  }

  private extractRegionFromAddress(address: any): string {
    const components = address?.address_components;
    if (!components?.length) {
      return '';
    }
    // Prefer state / admin area; fall back to index 3 (legacy behavior)
    for (let i = 0; i < components.length; i++) {
      const types = components[i]?.types || [];
      if (types.includes('administrative_area_level_1')) {
        return components[i]?.long_name || '';
      }
    }
    return components[3]?.long_name || '';
  }

  private hasValidNearbyCoords(): boolean {
    return this.normalizeCoord(this.latitude) != null && this.normalizeCoord(this.longitude) != null;
  }

  /**
   * Shared nearby location resolver used by:
   * - Where To → Search Nearby dropdown
   * - Near by You homepage cards (setHomeExperience)
   * - Browse All / search redirect to /shop
   */
  private resolveNearbyLocation(): Promise<{ latitude: number; longitude: number; city: string; region: string }> {
    return this.visitorService.getCurrent_location_nearBy().then((res: any) => {
      const geometry = res?.address?.geometry?.location;
      const geometryLat = this.normalizeCoord(
        typeof geometry?.lat === 'function' ? geometry.lat() : geometry?.lat
      );
      const geometryLng = this.normalizeCoord(
        typeof geometry?.lng === 'function' ? geometry.lng() : geometry?.lng
      );

      const latitude = this.normalizeCoord(res?.lat)
        ?? this.normalizeCoord(this.visitorService.latitude)
        ?? geometryLat;
      const longitude = this.normalizeCoord(res?.long)
        ?? this.normalizeCoord(this.visitorService.longitude)
        ?? geometryLng;

      if (latitude == null || longitude == null) {
        return Promise.reject({ code: 1, message: 'Location unavailable' });
      }

      const city = this.extractCityFromAddress(res?.address);
      const region = this.extractRegionFromAddress(res?.address) || city;

      this.latitude = latitude;
      this.longitude = longitude;
      if (city) {
        this.city = city;
      }
      if (region) {
        this.iplocation = { region };
      }

      return { latitude, longitude, city, region };
    });
  }

  private handleNearbyError(err: any, showToast = true): void {
    console.error('Error in nearby function:', err);
    if (showToast) {
      if (err?.code === 1) {
        this.toastr.errorToastr('Enable location to see nearby.', 'Error!');
      } else {
        this.toastr.errorToastr('An error occurred while fetching location.', 'Error!');
      }
    }
    this.cdref.markForCheck();
  }

  private applyNearbyToSearchInput(isMobile = false): void {
    if (!this.isBrowser) {
      return;
    }
    const label = this.city || this.iplocation?.region || 'Nearby';
    this.autocomplete_search_to = label;
    const idElement = isMobile
      ? document.getElementById('autoCompleteSearchValueMobile')
      : document.getElementById('autoCompleteSearchValue');
    if (idElement?.querySelector('input')) {
      idElement.querySelector('input').value = label;
    }
    if (isMobile) {
      this.isOpenDatePickerMobile = true;
    } else {
      this.isOpenDatePicker = true;
    }
  }

  /** Where To dropdown — Search Nearby */
  nearby(isMobile = false) {
    this.selectedNearby = true;
    this.resolveNearbyLocation().then(() => {
      this.applyNearbyToSearchInput(isMobile);
      this.cdref.markForCheck();
    }).catch((err) => {
      this.selectedNearby = false;
      this.handleNearbyError(err, true);
    });
  }

  /** Homepage "Near by You" cards */
  private loadNearbyHomeExperiences(): void {
    if (!this.isBrowser) {
      return;
    }
    this.resolveNearbyLocation().then((loc) => {
      // loc = {
      //   region: 'colorado',
      //   city: 'colorado',
      //   latitude: 39.7392,
      //   longitude: -104.9903
      // }
      const requestbody = {
        location: loc.region || loc.city || '',
        latitude: loc.latitude,
        longitude: loc.longitude,
        limit: this.getNearbyFetchLimit()
      };
      this.subscription.add(
        this.experienceService.homepage_exp_by_location(requestbody, this.tokenkey).subscribe(res => {
          if (res?.response == 'success') {
            this.setHomeExperience(res?.data);
          }
          this.cdref.markForCheck();
        })
      );
    }).catch((err) => {
      // Silent on initial homepage load (permission denied / unavailable)
      this.handleNearbyError(err, false);
    });
  }

  private navigateToNearbyShop(): void {
    const go = () => {
      this.router.navigate(['/shop'], {
        queryParams: this.nearbyShopQueryParams
      });
    };

    if (this.hasValidNearbyCoords()) {
      this.latitude = this.normalizeCoord(this.latitude);
      this.longitude = this.normalizeCoord(this.longitude);
      go();
      return;
    }

    this.resolveNearbyLocation().then(() => {
      go();
      this.cdref.markForCheck();
    }).catch((err) => {
      this.handleNearbyError(err, true);
    });
  }

  /** Browse All / search → /shop with nearby lat/long (resolves location if needed) */
  onBrowseNearbyShop(event?: Event): void {
    event?.preventDefault();
    this.navigateToNearbyShop();
  }

  /** Query params for Near by You → Browse All and nearby search redirect */
  get nearbyShopQueryParams(): Record<string, any> {
    return {
      nearby: 1,
      title: this.city || this.iplocation?.region || '',
      location: this.iplocation?.region || this.city || '',
      latitude: this.latitude,
      longitude: this.longitude,
      ...this.getBookingQueryParams()
    };
  }

  onSelectAutocompleteCoupleExperience(event) {
    this.autocomplete_couple_search = event?.value?.couple_full_name;
    this.couple_slug = event?.value?.slug;
    if (this.couple_slug) {
      this.router.navigate(['/registries/' + this.couple_slug]);
    }
  }
  onSelectAutocompleteCategoryExperience(event) {
    if (event?.value?.type == 'higher-level-category') {
      this.router.navigate(['/experience/' + event?.value?.value]);
    } else {
      this.router.navigate(['/gifts/' + event?.value?.value]);
    }

  }

  loadSearchHistory() {
    if (this.isCookies) {
      try {
        if (this.isBrowser) {

          this.searchHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];
        }
      } catch (e) {
        console.error('Error loading search history:', e);
        this.searchHistory = [];
      }
    }
  }

  loadContinuePlanningData() {
    if (this.isCookies && this.isBrowser) {
      try {
        this.continuePlanningData = JSON.parse(localStorage.getItem('searchedExp') || '[]') || [];
      } catch (e) {
        console.error('Error loading exp search history:', e);
        this.continuePlanningData = [];
      }
    } else {
      this.continuePlanningData = [];
    }
  }

  private asExperienceList(data: any): any[] {
    if (Array.isArray(data)) {
      return data.filter((item) => item && typeof item === 'object' && !Array.isArray(item));
    }
    if (data && typeof data === 'object') {
      return Object.values(data).filter((item) => item && typeof item === 'object' && !Array.isArray(item));
    }
    return [];
  }

  private readContinuePlanningList(): any[] {
    if (!this.isBrowser || !this.isCookies) {
      return [];
    }
    try {
      const parsed = JSON.parse(localStorage.getItem('searchedExp') || '[]');
      return this.asExperienceList(parsed);
    } catch {
      return this.asExperienceList(this.continuePlanningData);
    }
  }

  /**
   * Display caps per viewport:
   * - mobile: up to 6 nearby and 4 continue (independent sliders)
   * - tablet: up to 3 per section (stacked rows)
   * - desktop (same row, max 6 combined, max 4 per side when both exist):
   *   both ≥ 3 → 3|3; a side with 1–2 items keeps them all and the other side
   *   fills the remaining slots (4|1, 1|4, 2|4, 4|2, ...); single section → 6 nearby / 4 continue
   */
  private allocatePlanningNearbyCounts(nearbyLen: number, continueLen: number): { nearbyCount: number; continueCount: number } {
    if (this.planningNearbyMode === 'mobile') {
      return { nearbyCount: Math.min(6, nearbyLen), continueCount: Math.min(4, continueLen) };
    }
    if (this.planningNearbyMode === 'tablet') {
      return { nearbyCount: Math.min(3, nearbyLen), continueCount: Math.min(3, continueLen) };
    }

    if (!continueLen || !nearbyLen) {
      return { nearbyCount: Math.min(6, nearbyLen), continueCount: Math.min(4, continueLen) };
    }
    if (nearbyLen < 3) {
      return { nearbyCount: nearbyLen, continueCount: Math.min(4, continueLen, 6 - nearbyLen) };
    }
    if (continueLen < 3) {
      return { nearbyCount: Math.min(4, nearbyLen, 6 - continueLen), continueCount: continueLen };
    }
    return { nearbyCount: 3, continueCount: 3 };
  }

  /** Single source of truth for displayed nearby/continue cards. */
  syncPlanningNearbySection(): void {
    const nearbyAll = this.asExperienceList(this.home_experience);
    const continueAll = this.readContinuePlanningList();
    this.continuePlanningData = continueAll;

    const { nearbyCount, continueCount } = this.allocatePlanningNearbyCounts(
      nearbyAll.length,
      continueAll.length
    );

    this.nearbyExperiencesPreview = nearbyAll.slice(0, nearbyCount);
    this.continuePlanningPreview = continueAll.slice(0, continueCount);
    this.showNearbyBrowseAll = nearbyAll.length > nearbyCount;
    this.cdref.markForCheck();
  }

  /** Stable track ids so SSR/client list updates don't leave stale cards in the DOM. */
  trackPlanningNearbyItem(item: any, index: number): string | number {
    return item?.id ?? item?.slug ?? item?.params ?? item?.title ?? index;
  }

  get hasContinuePlanning(): boolean {
    return this.continuePlanningPreview.length > 0;
  }

  get hasNearbyExperiences(): boolean {
    return this.nearbyExperiencesPreview.length > 0;
  }

  get showPlanningNearbySection(): boolean {
    return this.planningNearbyReady && (this.hasContinuePlanning || this.hasNearbyExperiences);
  }

  get planningNearbyIsBoth(): boolean {
    return this.hasContinuePlanning && this.hasNearbyExperiences;
  }

  /**
   * Grid tracks per column. Desktop with both sections: tracks = own cards (column
   * width is sized to those cards in CSS). Single section: 6 tracks so cards keep the
   * same width and stay start-aligned. Tablet: 3 tracks.
   */
  get nearbyCardSlots(): number {
    return this.getPlanningNearbySlots(this.nearbyExperiencesPreview.length, this.continuePlanningPreview.length);
  }

  get continueCardSlots(): number {
    return this.getPlanningNearbySlots(this.continuePlanningPreview.length, this.nearbyExperiencesPreview.length);
  }

  private getPlanningNearbySlots(ownCount: number, otherCount: number): number {
    if (this.planningNearbyMode !== 'desktop') {
      return 3;
    }
    return otherCount ? ownCount : 6;
  }

  /** One extra item beyond the largest cap (6) so Browse All knows there is more to explore. */
  private getNearbyFetchLimit(): number {
    return 7;
  }

  private setHomeExperience(data: any): void {
    this.home_experience = data;
    this.home_exp_length = this.home_experience ? Object.keys(this.home_experience).length : 0;
    this.syncPlanningNearbySection();
  }

  readonly defaultExperienceImage = 'https://spurpanel.spurexperiences.com/public/img/vebolife_new_pro.png';

  getExperienceCardImage(item: any): string {
    const url = (item?.image_url || '').toString().trim();
    if (!url) {
      return this.defaultExperienceImage;
    }
    return url.includes('?') ? url : `${url}?width=360`;
  }

  categoryCardImage(url: string | undefined): string {
    const raw = (url || '').toString().trim();
    if (!raw) {
      return this.defaultExperienceImage;
    }
    if (raw.includes('?')) {
      return raw;
    }
    if (/\.gif($|\?)/i.test(raw)) {
      return `${raw}?width=360&format=webp&quality=40`;
    }
    return `${raw}?width=360`;
  }

  onExperienceImageError(event: Event): void {
    const img = event?.target as HTMLImageElement | null;
    if (img && !img.src.includes('vebolife_new_pro.png')) {
      img.src = this.defaultExperienceImage;
    }
  }

  getExperienceLocation(item: any): string {
    if (!item) {
      return '';
    }
    if (item.city) {
      return item.city;
    }
    if (item.city_name && item.state_name) {
      return `${item.city_name}, ${item.state_name}`;
    }
    if (item.city_name) {
      return item.city_name;
    }
    if (item.location) {
      return item.location;
    }
    return '';
  }

  getDestinationPlacesLabel(record: any): string {
    if (!record) {
      return '';
    }
    const count = record.total_place;
    if (count === undefined || count === null || count === '') {
      return '';
    }
    const numeric = Number(count);
    if (Number.isNaN(numeric)) {
      return '';
    }
    if (numeric === 0) {
      return ' ';
    }
    return `${numeric} ${numeric === 1 ? 'place' : 'places'}`;
  }

  getCategorySubtitle(category: any): string {
    if (!category) {
      return '';
    }
    return (category.h1_tag || '').toString().trim();
  }

  getTrendingLocation(exp: any): string {
    if (!exp) {
      return '';
    }
    return [exp.city, exp.state].filter((part) => !!part).join(', ');
  }

  getTrendingReviewScore(exp: any): string {
    const rating = Number(exp?.tripadvisor_overall_rating);
    if (!rating) {
      return '0';
    }
    return rating % 1 === 0 ? rating.toFixed(1) : String(rating);
  }

  getTrendingReviewCount(exp: any): number {
    const count = Number(exp?.tripadvisor_review_count);
    return count > 0 ? count : 0;
  }

  onFavoriteClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
  }

  autocompleteSearch(event?: any) {
    let query = event?.query?.trim();
    if (this.enteredValue && this.enteredValue !== '') {
      query = this.enteredValue;
    }
    let requestbody = { 'search': query };
    this.subscription.add(
      this.experienceService.searchExperienceAutocomplete(requestbody, this.tokenkey).subscribe(res => {
        if (res?.response == 'success') {
          this.autocompleteExpResults = res?.data;
          if (this.autocompleteExpResults && this.autocompleteExpResults?.length !== 0) {
            this.showRecentSearches = false;
          } else {
            this.showRecentSearches = false;
          }
          this.exp_image_url = res?.exp_image_url;
          this.location_image_url = res?.location_image_url;
          this.category_image_url = res?.category_image_url;
        }
        this.cdref.markForCheck();
      })
    );
  }

  onSearchBoxPointerDown(): void {
    this.searchBoxPointerActivated = true;
  }

  onFocusSearchBox(event?) {
    if (this.isItemSelected) return; // ⭐ prevent reopen after select

    if (event?.type === "focus") {
      // Only open after an explicit user click/tap on this field — never on page-load autofocus.
      if (!this.searchBoxPointerActivated) {
        if (this.isBrowser) {
          queueMicrotask(() => {
            this.autoComplete?.inputEL?.nativeElement?.blur();
            this.showRecentSearches = false;
            this.cdref.markForCheck();
          });
        }
        return;
      }

      if (this.enteredValue && this.enteredValue !== '') {
        this.showRecentSearches = false;

        this.autocompleteSearch();

        setTimeout(() => {
          this.autoComplete.show();
          this.cdref.markForCheck();
        }, 0);

      } else {
        this.showRecentSearches = true;
        this.cdref.markForCheck();
      }
    }
  }

  searchedInput(event) {
    let searchedValue = event?.target?.value?.trim();
    if (searchedValue && searchedValue !== '') {
      this.enteredValue = searchedValue;
    } else {
      this.enteredValue = '';
    }
  }

  onBlurSearchBox(event) {
    setTimeout(() => {
      this.showRecentSearches = false;
      this.searchBoxPointerActivated = false;
      this.autoComplete?.hide();
      this.cdref.markForCheck();
    }, 200);
  }

  selectRecentSearch(searchText?: any, isMobile?) {
    this.selectedNearby = false;
    this.autocomplete_search_to = searchText
    this.autocomplete_search_to['label'] = searchText?.title
    if (searchText?.type == 'exp') {
      if (searchText?.params) {
        if (isMobile) {
          this.router.navigate(['/experiences/' + searchText?.params]).then(() => {
            if (this.isBrowser) {
              window.location.reload();
            }
          });
        } else {
          this.router.navigate(['/experiences/' + searchText?.params]);
        }
      }
    } else {
      isMobile ? this.isOpenDatePickerMobile = true : this.isOpenDatePicker = true
    }
    if (this.isBrowser) {
      let idElement = isMobile ? document.getElementById('autoCompleteSearchValueMobile') : document.getElementById('autoCompleteSearchValue')
      idElement.querySelector('input').value = searchText?.title
    }
  }


  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    if (this.isBrowser) {
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
  }

  getCookie(data) {
    if (this.isBrowser) {
      let name = data + "=";

      let ca = document?.cookie?.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  }

  onSchedulingDateSelect(event: any) {
    if (event && event.length === 2) {
      const startDate = event[0];
      const endDate = event[1];
      const dateClasses: DatepickerDateCustomClasses[] = [];

      let currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        dateClasses.push({
          date: new Date(currentDate),
          classes: ['date-range-selected']
        });
        currentDate.setDate(currentDate.getDate() + 1);
      }

      this.dateCustomClasses = dateClasses;
    }
  }

  newSection: OwlOptions = {
    items: 5,
    dots: false,
    nav: true,
    autoplay: false,
    loop: false,
    rewind: true,
    margin: 15,
    navText: ["<i class='fas fa-chevron-left'></i>", "<i class='fas fa-chevron-right'></i>"],
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1
      },
      500: {
        items: 2
      },
      768: {
        items: 3
      },
      992: {
        items: 4.5
      },
      1200: {
        items: 5.5
      }
    }
  }

  popularDestinationOwl = {
    margin: 20,
    items: 5,
    dots: false,
    nav: true,
    autoplay: false,
    loop: false,
    rewind: true,
    navText: ["<i class='fas fa-chevron-left'></i>", "<i class='fas fa-chevron-right'></i>"],
    responsive: {
      0: {
        items: 1
      },
      500: {
        items: 2
      },
      768: {
        items: 3.1
      },
      992: {
        items: 4.5
      },
      1200: {
        items: 5.5
      }
    }
  }

  guestOwl = {
    margin: 20,
    items: 5,
    dots: false,
    nav: false,
    autoplay: true,
    loop: true,
    rewind: true,
    navText: ["<i class='fas fa-chevron-left'></i>", "<i class='fas fa-chevron-right'></i>"],
    responsive: {
      0: {
        items: 1.2
      },
      500: {
        items: 2.2
      },
      768: {
        items: 2.5
      },
      992: {
        items: 3
      },
      1200: {
        items: 3
      }
    }
  };

  updateScript() {
    const siteUrl = (globalConstant.WEBSITE_URL || 'https://spurexperiences.com/').replace(/\/?$/, '/');
    const pageUrl = siteUrl.replace(/\/$/, '') || 'https://spurexperiences.com';
    const experiences = Array.isArray(this.popularExperiences) ? this.popularExperiences : [];
    const categories = Array.isArray(this.popularCategories) ? this.popularCategories : [];
    const destinations = Array.isArray(this.popularDestinations) ? this.popularDestinations : [];

    const pageNodes: any[] = [];

    if (experiences.length) {
      pageNodes.push({
        '@type': 'ItemList',
        '@id': pageUrl + '/#popular-experiences',
        name: 'Popular Experiences',
        numberOfItems: experiences.length,
        itemListOrder: 'https://schema.org/ItemListOrderAscending',
        itemListElement: experiences.map((item: any, index: number) => {
          const itemName = item?.title || item?.name;
          const itemUrl = item?.slug ? (siteUrl + 'experiences/' + item.slug) : undefined;
          const imageUrl = this.mainService.resolveSchemaImageUrl(item);
          const image = this.mainService.buildImageObject(imageUrl, itemName);
          const aggregateRating = this.mainService.buildAggregateRatingFromItem(item);
          const offers = this.mainService.buildOfferFromItem(item, itemUrl);
          return {
            '@type': 'ListItem',
            position: index + 1,
            item: {
              '@type': 'Product',
              name: itemName,
              ...(itemUrl ? { url: itemUrl } : {}),
              ...(image ? { image } : {}),
              ...(aggregateRating ? { aggregateRating } : {}),
              ...(offers ? { offers } : {}),
            },
          };
        }),
      });
    }

    if (categories.length) {
      pageNodes.push({
        '@type': 'ItemList',
        '@id': pageUrl + '/#popular-categories',
        name: 'Popular Categories',
        numberOfItems: categories.length,
        itemListElement: categories.map((item: any, index: number) => {
          const itemName = item?.name || item?.title;
          const imageUrl = this.mainService.resolveSchemaImageUrl(item, {
            imageBaseUrl: this.category_image_url,
          });
          const image = this.mainService.buildImageObject(imageUrl, itemName);
          return {
            '@type': 'ListItem',
            position: index + 1,
            item: {
              '@type': 'CollectionPage',
              name: itemName,
              ...(item?.slug ? { url: siteUrl + 'experience/' + item.slug } : {}),
              ...(image ? { image } : {}),
            },
          };
        }),
      });
    }

    if (destinations.length) {
      pageNodes.push({
        '@type': 'ItemList',
        '@id': pageUrl + '/#popular-destinations',
        name: 'Popular Destinations',
        numberOfItems: destinations.length,
        itemListElement: destinations.map((item: any, index: number) => {
          const itemName = item?.name || item?.title;
          const imageUrl = this.mainService.resolveSchemaImageUrl(item, {
            imageBaseUrl: this.location_image_url,
          });
          const image = this.mainService.buildImageObject(imageUrl, itemName);
          return {
            '@type': 'ListItem',
            position: index + 1,
            item: {
              '@type': 'CollectionPage',
              name: itemName,
              ...(item?.slug ? { url: siteUrl + 'location-region/' + item.slug } : {}),
              ...(image ? { image } : {}),
            },
          };
        }),
      });
    }

    const heroVideoUrl = this.banner_video || this.section_data?.video_url;
    const heroThumb = this.section_data?.image_url || this.section_data?.featured_image_url;
    const heroUploadDate = (this.section_data?.updated_at || this.section_data?.created_at || '')
      .toString().trim().slice(0, 10) || undefined;
    const videoNode = this.mainService.buildVideoObject({
      name: this.section_data?.title || this.section_data?.name || 'Spur Experiences',
      contentUrl: heroVideoUrl,
      thumbnailUrl: heroThumb,
      uploadDate: heroUploadDate,
      description: this.section_data?.meta_description || this.section_data?.seo_description || '',
    });
    if (videoNode) {
      pageNodes.push(videoNode);
    }

    this.mainService.updateGraphSchema({
      pageUrl,
      breadcrumbs: [{ name: 'Home', url: siteUrl }],
      pageNodes,
      siteUrl,
    });
  }

  private readonly popularExperiencesSessionKey = 'homepagePopularExperiences';

  private normalizePopularExperiences(data: any): any[] {
    return this.asExperienceList(data);
  }

  private getPopularExperiencesFromSession(): any[] | null {
    if (!this.isBrowser) {
      return null;
    }
    try {
      const raw = sessionStorage.getItem(this.popularExperiencesSessionKey);
      if (!raw) {
        return null;
      }
      const parsed = this.normalizePopularExperiences(JSON.parse(raw));
      return parsed.length ? parsed : null;
    } catch {
      return null;
    }
  }

  private storePopularExperiencesInSession(data: any[]): void {
    if (!this.isBrowser || !data?.length) {
      return;
    }
    try {
      sessionStorage.setItem(this.popularExperiencesSessionKey, JSON.stringify(data));
    } catch {
      // Ignore quota / private-mode failures.
    }
  }

  private persistPopularExperiences(data: any[]): void {
    if (!data?.length) {
      return;
    }
    popularExperiencesMemoryCache = data;
    this.storePopularExperiencesInSession(data);
  }

  /** Constructor / ngOnInit: read memory first, then sessionStorage. */
  private restorePopularExperiencesFromCache(remount = true): void {
    if (!this.isBrowser) {
      return;
    }
    let data: any[] | null = null;
    if (popularExperiencesMemoryCache?.length) {
      data = [...popularExperiencesMemoryCache];
    } else {
      const cached = this.getPopularExperiencesFromSession();
      if (cached?.length) {
        popularExperiencesMemoryCache = cached;
        data = [...cached];
      }
    }
    if (!data?.length) {
      return;
    }
    if (remount) {
      this.applyPopularExperiences(data);
    } else {
      this.popularExperiences = data;
    }
  }

  /** Paint data and remount the swiper so SPA return visits show slides. */
  private applyPopularExperiences(data: any[]): void {
    this.popularExperiences = data || [];
    if (!this.isBrowser) {
      this.trendingSwiperVisible = this.popularExperiences.length > 0;
      return;
    }
    this.trendingSwiperVisible = false;
    try {
      this.cdref.detectChanges();
    } catch {
      // View may not exist yet (e.g. early lifecycle).
    }
    if (!this.popularExperiences.length) {
      return;
    }
    this.trendingSwiperVisible = true;
    try {
      this.cdref.detectChanges();
    } catch {
      this.cdref.markForCheck();
    }
    this.refreshTrendingExperiencesSwiper();
  }

  /** First visit: assign from API and cache. Later visits: reuse memory/session. */
  private assignPopularExperiences(apiData: any): void {
    if (this.isBrowser) {
      if (popularExperiencesMemoryCache?.length) {
        this.applyPopularExperiences([...popularExperiencesMemoryCache]);
        return;
      }
      const cached = this.getPopularExperiencesFromSession();
      if (cached?.length) {
        popularExperiencesMemoryCache = cached;
        this.applyPopularExperiences([...cached]);
        return;
      }
    }
    const data = this.normalizePopularExperiences(apiData);
    this.persistPopularExperiences(data);
    this.applyPopularExperiences(data);
  }

  /** Swiper Element needs initialize() after Angular remounts the host. */
  private refreshTrendingExperiencesSwiper(): void {
    if (!this.isBrowser || !this.popularExperiences?.length) {
      return;
    }
    this.ngZone.runOutsideAngular(() => {
      const tryRefresh = () => {
        const el = this.swiperEl4()?.nativeElement as any;
        if (!el) {
          return;
        }
        const slideCount = el.querySelectorAll?.('swiper-slide')?.length || 0;
        if (slideCount < 1) {
          return;
        }
        try {
          if (typeof el.initialize === 'function' && !el.swiper) {
            el.initialize();
          }
          el.swiper?.update?.();
          el.swiper?.slideTo?.(0, 0, false);
        } catch {
          // Swiper may not be upgraded yet.
        }
      };
      requestAnimationFrame(() => {
        setTimeout(tryRefresh, 0);
        setTimeout(tryRefresh, 50);
        setTimeout(tryRefresh, 150);
        setTimeout(tryRefresh, 350);
      });
    });
  }

  private applyHomePageData(res: any): void {
    if (res?.response != 'success') {
      return;
    }
    this.section_data = res?.data;
    if (this.section_data) {
      this.addMetaTags();
      this.updateScript();
    }
    this.banner_video = res?.data?.video_url;
    const sections = res?.data?.sections;
    const sectionMap = new Map(sections?.map((s: any) => [s.id, s]));

    this.see_world_section = sectionMap.get(127);
    this.sectionData = this.see_world_section?.section_data;
    this.guest_about_spur = sectionMap.get(128);
    this.gift_experiences_data = sectionMap.get(129);
    this.circleData = sectionMap.get(130);
    this.wedding_registry = sectionMap.get(131);
    this.spurExperience = sectionMap.get(132);
    this.home_mobile_banner = sectionMap.get(133);
    this.download_app_section = sectionMap.get(141);
    this.influencerSecton = sectionMap.get(139113);
    this.providerSection = sectionMap.get(139114);
    this.spurfectRewardsSection = sectionMap.get(139138) || null;
    this.prepareSpurfectRewardsCopy();

    this.seasonalPromotionsData = res?.data?.seasonal_promotion_data;
    this.applySeasonalGallery(this.seasonalPromotionsData);
    this.resolveBannerMode();

    this.popularDestinations = res?.extra_data['location_list'];
    this.popularCategories = res?.extra_data['category_list'];
    this.assignPopularExperiences(res?.extra_data['popular_experiences']);
    this.brandLogos = res?.extra_data['spur_partners'];
    this.section_image_url = res?.image_url;
    this.certificate_data = res['gift_certificate'];
    this.wedding_registry_background = this.is_mobile_view && this.wedding_registry?.section_data?.length > 0
      && this.wedding_registry?.section_data[0]?.image_url ? this.wedding_registry?.section_data[0]?.image_url :
      this.wedding_registry?.image_url;
    this.updateScript();
    this.isPageReady = true;
  }

  ngOnInit() {
    // Re-check cache here too (constructor may have run before session was available).
    if (this.isBrowser && !this.popularExperiences?.length) {
      this.restorePopularExperiencesFromCache(false);
    }
    this.getAllExperienceData();
    if (this.isBrowser) {
      this.base_website_url = window.location.origin;
    }

    const resolvedPageData = this.activatedRoute.snapshot.data['pageData'];
    if (resolvedPageData?.response === 'success') {
      this.applyHomePageData(resolvedPageData);
    }

    this.subscription.add(
      this.activatedRoute.data.subscribe(data => {
        const res = data['pageData'];
        if (res?.response == 'success') {
          this.applyHomePageData(res);
        } else if (res == null) {
          this.isPageReady = true;
        }
        this.cdref.markForCheck();
      })
    );

    this.isCookies = this.getCookie('acceptCookies') !== "";
    this.loadSearchHistory();
    this.loadContinuePlanningData();

    if (this.isBrowser) {
      this.loadNearbyHomeExperiences();
    }

    this.SubscribeForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern(HomepageNew.EMAIL)]],
    });
    this.messageService.sendAutocompleteSearchParameterMessage({ 'search_type': 'search-autocomplete' });

    /*  if(this.isBrowser && this.isLive) {
       let isBoat = this.isSitePerformanceBoat();
       if (!isBoat) {
         // this.load_facebook_script();
       }
     } */
  }

  ngOnChanges() {
    if (this.images?.length) {
      this.activeIndex = 0;
    }
  }

  /** Always returns correct slide data */
  get activeItem() {
    return this.images?.[this.activeIndex];
  }

  /** Current seasonal slide for overlay copy (static first slide until Galleria is ready) */
  get heroSeasonalSlide() {
    if (this.bannerMode === 'seasonal-images') {
      if (this.images?.length > 1 || this.isSliderReady) {
        return this.activeItem;
      }
      return this.images?.[0];
    }
    if (this.bannerMode === 'seasonal-video') {
      const video = this.seasonalPromotionsData?.video;
      if (!video?.media) {
        return null;
      }
      return {
        heading: video?.title,
        subHeading: video?.description,
        buttonText: video?.button_text,
        buttonUrl: video?.button_url,
        setOverlay: video?.apply_overlay
      };
    }
    return null;
  }

  resolveBannerMode(): void {
    if (this.seasonalPromotionsData?.data) {
      this.bannerMode = this.images?.length > 0 ? 'seasonal-images' : 'seasonal-video';
    } else {
      this.bannerMode = 'default';
    }
  }


  /** Section id 139127 — Spurfect Rewards homepage promo. */
  prepareSpurfectRewardsCopy(): void {
    const section = this.spurfectRewardsSection;
    if (!section) {
      this.spurfectRewardsTitleLead = '';
      this.spurfectRewardsTitleAccent = '';
      this.spurfectRewardsDescriptionHtml = '';
      return;
    }

    const title = this.decodeSectionText(section.other_description);
    const parts = title.split(/\s+/).filter(Boolean);
    if (parts.length <= 1) {
      this.spurfectRewardsTitleLead = title;
      this.spurfectRewardsTitleAccent = '';
    } else {
      this.spurfectRewardsTitleLead = parts.slice(0, -1).join(' ');
      this.spurfectRewardsTitleAccent = parts[parts.length - 1];
    }

    const description = (section.description || '').trim();
    this.spurfectRewardsDescriptionHtml = description
      ? description.replace(/More\s+([A-Za-z]+)\.?/g, 'More <strong>$1.</strong>')
      : '';
  }


  /** CMS may URL-encode other_description values. */
  private decodeSectionText(value: string | null | undefined): string {
    if (!value || value === 'null') {
      return '';
    }
    try {
      return decodeURIComponent(value.replace(/\+/g, ' ')).trim();
    } catch {
      return String(value).trim();
    }
  }

  applySeasonalGallery(seasonalData: any): void {
    if (!seasonalData) {
      this.images = undefined;
      return;
    }
    const galleryImages = (seasonalData?.gallery || []).map((item: any, index: number) => ({
      itemImageSrc: item?.media,
      thumbnailImageSrc: item?.media,
      alt: item?.button_text || `Image ${index + 1}`,
      title: item?.button_text || `Title ${index + 1}`,
      buttonText: item?.button_text,
      buttonUrl: item?.button_url,
      heading: item?.title,
      subHeading: item?.description,
      setOverlay: item?.apply_overlay,
      responsiveImage: item?.responsive_media
    }));

    this.images = galleryImages;
    this.isSliderReady = false;
    this.injectHeroImagePreloads(galleryImages?.[0]);
  }

  goToPrevHeroSlide(): void {
    if (!this.images?.length) {
      return;
    }
    this.isSliderReady = true;
    this.activeIndex = (this.activeIndex - 1 + this.images.length) % this.images.length;
    this.cdref.markForCheck();
  }

  goToNextHeroSlide(): void {
    if (!this.images?.length) {
      return;
    }
    this.isSliderReady = true;
    this.activeIndex = (this.activeIndex + 1) % this.images.length;
    this.cdref.markForCheck();
  }

  private injectHeroImagePreloads(firstImage: any): void {
    if (this.isBrowser || !firstImage || !this.document) {
      return;
    }
    const existingLink = this.document.querySelector('link[rel="preload"][media*="width"]');
    if (existingLink) {
      return;
    }

    const mobileSrcset = firstImage.responsiveImage
      ? `${firstImage.responsiveImage}?width=480 480w, ${firstImage.responsiveImage}?width=768 768w`
      : (firstImage.itemImageSrc ? `${firstImage.itemImageSrc}?width=480 480w, ${firstImage.itemImageSrc}?width=768 768w` : '');

    if (mobileSrcset) {
      const linkMobile = this.renderer.createElement('link');
      this.renderer.setAttribute(linkMobile, 'rel', 'preload');
      this.renderer.setAttribute(linkMobile, 'as', 'image');
      this.renderer.setAttribute(linkMobile, 'imagesrcset', mobileSrcset);
      this.renderer.setAttribute(linkMobile, 'imagesizes', '100vw');
      this.renderer.setAttribute(linkMobile, 'media', '(max-width: 767px)');
      this.renderer.setAttribute(linkMobile, 'fetchpriority', 'high');
      this.renderer.appendChild(this.document.head, linkMobile);
    }

    if (firstImage.itemImageSrc) {
      const linkDesktop = this.renderer.createElement('link');
      this.renderer.setAttribute(linkDesktop, 'rel', 'preload');
      this.renderer.setAttribute(linkDesktop, 'as', 'image');
      this.renderer.setAttribute(linkDesktop, 'imagesrcset', `${firstImage.itemImageSrc}?width=1200 1200w`);
      this.renderer.setAttribute(linkDesktop, 'imagesizes', '100vw');
      this.renderer.setAttribute(linkDesktop, 'media', '(min-width: 768px)');
      this.renderer.setAttribute(linkDesktop, 'fetchpriority', 'high');
      this.renderer.appendChild(this.document.head, linkDesktop);
    }
  }

  splitHeroTitle(title: string | null | undefined): { accent: string; rest: string } {
    if (!title) {
      return { accent: '', rest: '' };
    }
    const trimmed = String(title).trim();
    const spaceIdx = trimmed.search(/\s/);
    if (spaceIdx === -1) {
      return { accent: trimmed, rest: '' };
    }

    // Check if the title starts with "collect moments" (case-insensitive)
    const words = trimmed.split(/\s+/);
    if (
      words.length >= 2 &&
      words[0].toLowerCase() === 'collect' &&
      words[1].toLowerCase() === 'moments,'
    ) {
      const accent = `${words[0]} ${words[1]}`;
      const rest = trimmed.slice(accent.length).trim();
      return { accent, rest };
    }

    return {
      accent: trimmed.slice(0, spaceIdx),
      rest: trimmed.slice(spaceIdx + 1).trim()
    };
  }

  pictureSrcset(imageUrl: string | undefined, widths: number[]): string {
    if (!imageUrl) {
      return '';
    }
    return widths.map(w => `${imageUrl}?width=${w} ${w}w`).join(', ');
  }

  redirectToBtnUrl(url: string): void {
    if (!url) return;
    window.location.href = url;
  }

  get subscribeFormCtrl() {
    return this.SubscribeForm.controls;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.loading = false;
      this.cdref.markForCheck();
    }, 0);
    if (this.isBrowser) {
      setTimeout(() => {
        this.isSliderReady = true;
        this.cdref.markForCheck();
      }, 1500);
      var brodPopup = document.getElementById("popup-broadcast")
      if (brodPopup != null && brodPopup != undefined) {
        brodPopup.classList.add('open');

        document.querySelector(".close-broadcast").addEventListener("click", (e) => {
          brodPopup.classList.remove('open');
        });
      }
    }
  }

  closeVideoPopup(event) {
    if (this.isBrowser) {
      var veboBody = document.getElementById("vebo_body");
      veboBody.classList.remove('videoPopup-hidden');
      document.getElementById('video-popup-wrapper').hidden = true;
      var videoFarme = document.getElementById('videoIframe');
      videoFarme.removeAttribute("src");
    }
  }

  mobileView(eve) {
    this.mobBannerView = eve;
    this.location_booking = "";
    if (eve == 'bookNow_view') {
      this.mobBannerImage = this.home_mobile_banner?.section_data[0]?.image_url;
      this.mobBannerVideo = this.home_mobile_banner?.section_data[0]?.video_url;
      this.videoElement?.nativeElement?.load();
    } else if (eve == 'gift_view') {
      this.mobBannerImage = this.home_mobile_banner?.section_data[1]?.image_url;
      this.mobBannerVideo = this.home_mobile_banner?.section_data[1]?.video_url;
      this.videoElement?.nativeElement?.load();
    } else if (eve == 'wedding_view') {
      this.mobBannerImage = this.home_mobile_banner?.section_data[2]?.image_url;
      this.mobBannerVideo = this.home_mobile_banner?.section_data[2]?.video_url;
      this.videoElement?.nativeElement?.load();
    } else {
      this.mobBannerImage = this.section_image_url + 'home_sections/' + this.home_mobile_banner?.image;
      this.mobBannerVideo = this.home_mobile_banner?.video_url;
      this.videoElement?.nativeElement?.load();
    }
    if (this.isBrowser) {
      window.scrollTo(0, 0);
    }
  }

  onSubscribeSubmit() {
    this.submitted = true;
    this.loading = true;
    this.subscribe_error = false;
    this.subscribe_error_message = '';

    // stop here if form is invalid
    if (this.SubscribeForm.invalid) {
      this.loading = false;
      return;
    } else {

      let reuestBody = { 'email': this.SubscribeForm.get('email').value.replace(/^\s+|\s+$/gm, '') };
      this.subscription.add(
        this.mainService.subscribeUser(reuestBody).subscribe(res => {
          if (res?.response == "success") {
            this.loading = false;
            this.SubscribeForm.controls['email'].setValue('');
            this.toastr.successToastr(res?.message, "Success")
            // this.router.navigate(['/thanksforsubscribing']);
            this.submitted = false;
          } else {
            this.loading = false;
            this.subscribe_error = true;
            this.subscribe_error_message = res?.message;

          }
          this.cdref.markForCheck();
        })
      );
    }
  }

  add_gift_certificate() {
    this.router.navigate(['/gift-card']);
  }

  getAllExperienceData() {
    if (this.subscription) {
      this.subscription.add(
        this.messageService.getAutocompleteSearchParameterMessage().subscribe(messageData => {
          this.exp_slug = messageData?.data_slug;
          if (this.exp_slug)
            this.router.navigate(['/experiences/' + this.exp_slug]);
          this.cdref.markForCheck();
        })
      );
    }
  }

  onShowPicker(event) {
    const dayHoverHandler = event.dayHoverHandler;
    if (this.isBrowser) {
      const hoverWrapper = (hoverEvent) => {
        const { cell, isHovered } = hoverEvent;
        if ((isHovered &&
          !!navigator.platform &&
          /iPad|iPhone|iPod/.test(navigator.platform)) &&
          'ontouchstart' in window
        ) {
          (this._picker as any)._datepickerRef.instance.daySelectHandler(cell);
        }

        return dayHoverHandler(hoverEvent);
      };
      // event.dayHoverHandler = hoverWrapper;
      const touchHandler = (event) => hoverWrapper(event);
      document.addEventListener('touchstart', touchHandler, { passive: true });
    }
  }

  search_clear() {
    this.autocompleteExpResults = [];
  }

  search_couple_clear() {
    this.autocompleteCoupleResults = [];
  }

  search_category_clear() {
    this.autocompleteCategoryResults = [];
  }

  ngOnDestroy() {
    if (this.subscription != undefined && this.subscription != null) {
      this.subscription.unsubscribe();
    }

    // this.instaWidget.nativeElement.innerHTML = '';
  }

  onResize(event) {
    if (event.target.innerWidth < 768) {
      this.is_mobile_view = true;
    } else {
      this.is_mobile_view = false;
    }
  }


  clearDate() {
    this.selectedDateRange = [];
  }

  private getBookingQueryParams(): Record<string, any> {
    const queryParams: Record<string, any> = {};
    if (this.selectedDateRange?.length > 0) {
      queryParams.is_booking = 1;
      const startDate = this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd');
      const endDate = this.datePipe.transform(
        this.selectedDateRange.length > 1 ? this.selectedDateRange[1] : this.selectedDateRange[0],
        'yyyy-MM-dd'
      );
      if (startDate) {
        queryParams.start_date = startDate;
      }
      if (endDate) {
        queryParams.end_date = endDate;
      }
    }
    return queryParams;
  }

  private isEmptySlug(value: any): boolean {
    return value == null || value === '';
  }

  private navigateToLocationRegion(event: any): void {
    const queryParams = this.getBookingQueryParams();
    const slug = this.exp_slug || event?.slug || event?.value || event?.params;
    if (!slug) {
      return;
    }

    // Autocomplete "location" uses country_slug/state_slug.
    // Recent/"location-list" uses super_parent_location_slug/parent_location_slug.
    // State rows store the country in state_slug / parent_location_slug.
    const countrySlug = event?.type === 'location-list'
      ? event?.super_parent_location_slug
      : event?.country_slug;
    const stateSlug = event?.type === 'location-list'
      ? event?.parent_location_slug
      : event?.state_slug;

    if (this.isEmptySlug(countrySlug) && this.isEmptySlug(stateSlug)) {
      this.router.navigate(['/location-region/' + slug], { queryParams });
    } else if (this.isEmptySlug(countrySlug) && !this.isEmptySlug(stateSlug)) {
      this.router.navigate(['/location-region/' + stateSlug + '/' + slug], { queryParams });
    } else if (!this.isEmptySlug(countrySlug) && !this.isEmptySlug(stateSlug)) {
      this.router.navigate(['/location-region/' + countrySlug + '/' + stateSlug + '/' + slug], { queryParams });
    }
  }

  private navigateToExperienceCategory(event: any): void {
    const queryParams = this.getBookingQueryParams();
    const slug = this.exp_slug || event?.value || event?.params;
    if (!slug) {
      return;
    }
    this.router.navigate(['/experience/' + slug], { queryParams });
  }

  clearRecentSearch() {
    this.searchHistory = []
    if (this.isBrowser) {
      if (localStorage.getItem('searchHistory')) {
        localStorage.removeItem('searchHistory')
      }
    }
  }

  clearRecentSearchedExp() {
    this.continuePlanningData = []
    if (this.isBrowser) {
      if (localStorage.getItem('searchedExp')) {
        localStorage.removeItem('searchedExp')
      }
    }
    this.syncPlanningNearbySection();
  }



  onEnterSearch(event: KeyboardEvent) {
    event.preventDefault();

    let selectedItem = this.autocomplete_search_to;

    // CASE 1: nothing selected → pick first suggestion
    if (!selectedItem && this.autocompleteExpResults?.length > 0) {
      selectedItem = this.autocompleteExpResults[0];
    }

    // CASE 2: still nothing → use typed value
    if (!selectedItem) {
      selectedItem = this.enteredValue;
    }

    // 🚀 FINAL CALL (same as button click)
    this.onSelectAutocompleteExperience(selectedItem, true, false);
  }

  onSelectAutocompleteExperience(event, isClick = false, isMobile = false) {
    this.exp_slug = event?.value;

    // Nearby search → shop with lat/long (shared resolveNearbyLocation path)
    if (isClick && this.selectedNearby === true) {
      this.navigateToNearbyShop();
      return;
    }

    if (!isClick) {
      if (!event && !this.autocomplete_search) {
        this.router.navigate(['/shop'])
      } else if (!event?.label && this.autocomplete_search) {
        this.router.navigate(['/shop'], { queryParams: { title: this.autocomplete_search } })
      }
    } else {
      if (!event) {
        this.router.navigate(['/shop'])
      } else if (!event?.label) {
        this.router.navigate(['/shop'], { queryParams: { title: event } })
      }
    }
    switch (event?.type) {
      case "exp":
        if (this.exp_slug) {
          this.router.navigate(['/experiences/' + this.exp_slug]);
          // set close
        }
        break;
      case "location-list":
      case "location":
        this.navigateToLocationRegion(event);
        break;
      case "higher-level-category":
      case "category":
        if (isClick) {
          if (event?.id && event?.id != '') {
            this.navigateToExperienceCategory(event);
          } else {
            this.router.navigate(['/shop'], {
              queryParams: {
                title: event.label,
                search_id: event.id,
                type: event.type,
                ...this.getBookingQueryParams()
              }
            });
          }
        } else {
          this.router.navigate(['/shop'], {
            queryParams: {
              title: this.autocomplete_search,
            }
          });
        }
        break;
      case undefined:
        if (isClick && this.selectedNearby === false) {
          let idElement = isMobile ? document.getElementById('autoCompleteSearchValueMobile') : document.getElementById('autoCompleteSearchValue')

          this.router.navigate(['/shop'], {
            queryParams: {
              title: idElement.querySelector('input').value ? idElement.querySelector('input').value : '',
              ...this.getBookingQueryParams()
            }
          });
        } else {
          this.router.navigate(['/shop'], {
            queryParams: {
              title: this.autocomplete_search,
            }
          });
        }
        break;
    }
  }

  onSelectRedirect(event, isClick = false, isMobile = false) {
    this.exp_slug = event?.value;

    // Nearby search → shop with lat/long (shared resolveNearbyLocation path)
    if (isClick && this.selectedNearby === true) {
      this.navigateToNearbyShop();
      return;
    }

    if (!isClick) {
      if (!event && !this.autocomplete_search) {
        this.router.navigate(['/shop'])
      } else if (!event?.label && this.autocomplete_search) {
        this.router.navigate(['/shop'], { queryParams: { title: this.autocomplete_search } })
      }
    } else {
      if (!event) {
        this.router.navigate(['/shop'])
      } else if (!event?.label) {
        this.router.navigate(['/shop'], { queryParams: { title: event } })
      }
    }
    switch (event?.type) {
      case "exp":
        if (this.exp_slug) {
          this.router.navigate(['/experiences/' + this.exp_slug]);
          // set close
        }
        break;
      case "location-list":
      case "location":
        this.navigateToLocationRegion(event);
        break;
      case "higher-level-category":
      case "category":
        if (isClick) {
          this.navigateToExperienceCategory(event);
        } else {
          this.router.navigate(['/shop'], {
            queryParams: {
              title: this.autocomplete_search,
            }
          });
        }
        break;
      case undefined:
        if (isClick && this.selectedNearby === false) {

          this.router.navigate(['/shop'], {
            queryParams: {
              title: event?.label ? event?.label : '',
              ...this.getBookingQueryParams()
            }
          });
        } else {
          this.router.navigate(['/shop'], {
            queryParams: {
              title: this.autocomplete_search,
            }
          });
        }
        break;
    }
  }

  getImageUrl(imageUrl: string, index: number): string {
    if (index < 3) {
      return `${imageUrl}?width=150`;
    } else if (index < 6) {
      return `${imageUrl}?height=565`;
    } else if (index < 9) {
      return `${imageUrl}?width=150`;
    } else {
      return imageUrl;
    }
  }

  setGlobalPassiveEvents() {
    this.ngZone.runOutsideAngular(() => {
      if (this.isBrowser) {
        const passiveEvents = ['touchstart', 'touchmove', 'wheel', 'scroll'];
        passiveEvents.forEach((eventType) => {
          window.addEventListener(eventType, () => { }, { passive: true });
        });
      }
    });
  }

  addMetaTags() {
    this.cmsPageSeoService.applyCmsPageSeo(this.section_data, {
      pageUrl: this.pageUrl || this.normalizeUrl(String(this.siteUrl || '')),
      schemaType: 'WebPage',
      skipSchema: true,
    });
  }

  redirectToUrl(url: string): void {
    if (url) {
      window.open(url, '_blank');
    }
  }
  trackByTestimonial = (_: number, record: any) =>
    record?.id ?? record?.title ?? record?.updated_at ?? _;

  /**
   * Testimonials are inside @defer (on viewport). Manual init avoids the
   * common loop+centeredSlides blank-left-slot on first paint (2 cards with
   * an empty third column). We start on slide 1 so prev/active/next are all
   * real slides, then enable autoplay.
   */
  private refreshTestimonialSwiper(): void {
    if (!this.isBrowser || this.testimonialSwiperReady) {
      return;
    }

    const el = this.swiperEl5()?.nativeElement as any;
    if (!el) {
      return;
    }

    const slideCount = this.guest_about_spur?.section_data?.length || 0;
    if (slideCount < 1) {
      return;
    }

    const getConfig = () => {
      const width = window.innerWidth;
      if (width >= 1200) {
        return { slidesPerView: 3, spaceBetween: 28 };
      }
      if (width >= 992) {
        return { slidesPerView: 3, spaceBetween: 24 };
      }
      if (width >= 768) {
        return { slidesPerView: 2.15, spaceBetween: 22 };
      }
      if (width >= 575) {
        return { slidesPerView: 1.15, spaceBetween: 18 };
      }
      return { slidesPerView: 1, spaceBetween: 16 };
    };

    const setup = () => {
      if (this.testimonialSwiperReady && el.swiper) {
        return;
      }

      // Wait until ngFor has painted slides into the custom element.
      const renderedSlides = el.querySelectorAll?.('swiper-slide')?.length || 0;
      if (renderedSlides < 1) {
        return;
      }

      const { slidesPerView, spaceBetween } = getConfig();
      const canLoop = renderedSlides > Math.ceil(slidesPerView);

      Object.assign(el, {
        slidesPerView,
        spaceBetween,
        centeredSlides: true,
        loop: canLoop,
        loopAdditionalSlides: Math.ceil(slidesPerView),
        breakpoints: this.reviewBreakpoints,
        autoplay: false,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        watchSlidesProgress: true
      });

      try {
        if (!el.swiper) {
          el.initialize();
        }
      } catch {
        return;
      }

      const swiper = el.swiper;
      if (!swiper) {
        return;
      }

      swiper.update?.();
      swiper.loopFix?.();

      // Start on slide 1 so the left/center/right slots are all filled immediately
      // (index 0 often leaves the "prev" column empty until the first autoplay tick).
      if (renderedSlides >= 3 && slidesPerView >= 2) {
        if (typeof swiper.slideToLoop === 'function' && canLoop) {
          swiper.slideToLoop(1, 0, false);
        } else {
          swiper.slideTo(Math.min(1, renderedSlides - 1), 0, false);
        }
      }

      swiper.loopFix?.();
      swiper.update?.();

      // Enable autoplay only after the first correct 3-up frame.
      swiper.params.autoplay = { ...this.testimonialAutoplay };
      swiper.autoplay?.start?.();

      this.testimonialSwiperReady = true;
      this.cdref.markForCheck();
    };

    this.ngZone.runOutsideAngular(() => {
      requestAnimationFrame(() => {
        setTimeout(setup, 0);
        setTimeout(setup, 100);
        setTimeout(setup, 250);
        setTimeout(setup, 500);
      });
    });
  }

  slideNext(slider: string) {
    if (slider === 'swiperEl') {
      const swiper = this.swiperEl()?.nativeElement?.swiper;
      swiper.slideNext()
    } else if (slider === 'swiperEl2') {
      const swiper = this.swiperEl2()?.nativeElement?.swiper;
      swiper.slideNext()
    } else if (slider === 'swiperEl3') {
      const swiper = this.swiperEl3()?.nativeElement?.swiper;
      swiper.slideNext()
    } else if (slider === 'swiperEl4') {
      const swiper = this.swiperEl4()?.nativeElement?.swiper;
      swiper.slideNext()
    } else if (slider === 'swiperEl5') {
      const swiper = this.swiperEl5()?.nativeElement?.swiper;
      swiper.slideNext()
    } else if (slider === 'swiperEl6') {
      const swiper = this.swiperEl6()?.nativeElement?.swiper;
      // swiper.slideNext()
    } else {
      console.error('Invalid slider identifier');
    }
  }

  slidePrev(slider: string) {
    if (slider === 'swiperEl') {
      const swiper = this.swiperEl()?.nativeElement?.swiper;
      swiper.slidePrev()
    } else if (slider === 'swiperEl2') {
      const swiper = this.swiperEl2()?.nativeElement?.swiper;
      swiper.slidePrev()
    } else if (slider === 'swiperEl3') {
      const swiper = this.swiperEl3()?.nativeElement?.swiper;
      swiper.slidePrev()
    } else if (slider === 'swiperEl4') {
      const swiper = this.swiperEl4()?.nativeElement?.swiper;
      swiper.slidePrev()
    } else if (slider === 'swiperEl5') {
      const swiper = this.swiperEl5()?.nativeElement?.swiper;
      swiper.slidePrev()
    } else if (slider === 'swiperEl6') {
      const swiper = this.swiperEl6()?.nativeElement?.swiper;
      // swiper.slidePrev()
    } else {
      console.error('Invalid slider identifier');
    }
  }

  pauseSwiper(slider: string) {
    if (slider === 'swiperEl') {
      const swiper = this.swiperEl()?.nativeElement?.swiper;
      swiper?.autoplay?.stop();
    } else if (slider === 'swiperEl2') {
      const swiper = this.swiperEl2()?.nativeElement?.swiper;
      swiper?.autoplay?.stop();
    } else if (slider === 'swiperEl3') {
      const swiper = this.swiperEl3()?.nativeElement?.swiper;
      swiper?.autoplay?.stop();
    } else if (slider === 'swiperEl4') {
      const swiper = this.swiperEl4()?.nativeElement?.swiper;
      swiper?.autoplay?.stop();
    } else if (slider === 'swiperEl5') {
      const swiper = this.swiperEl5()?.nativeElement?.swiper;
      swiper?.autoplay?.stop();
    } else if (slider === 'swiperEl6') {
      const swiper = this.swiperEl6()?.nativeElement?.swiper;
      // swiper?.autoplay?.stop();
    } else {
      console.error('Invalid slider identifier');
    }
  }

  resumeSwiper(slider: string) {
    if (slider === 'swiperEl') {
      const swiper = this.swiperEl()?.nativeElement?.swiper;
      swiper?.autoplay?.start();
    } else if (slider === 'swiperEl2') {
      const swiper = this.swiperEl2()?.nativeElement?.swiper;
      swiper?.autoplay?.start();
    } else if (slider === 'swiperEl3') {
      const swiper = this.swiperEl3()?.nativeElement?.swiper;
      swiper?.autoplay?.start();
    } else if (slider === 'swiperEl4') {
      const swiper = this.swiperEl4()?.nativeElement?.swiper;
      swiper?.autoplay?.start();
    } else if (slider === 'swiperEl5') {
      const swiper = this.swiperEl5()?.nativeElement?.swiper;
      swiper?.autoplay?.start();
    } else if (slider === 'swiperEl6') {
      const swiper = this.swiperEl6()?.nativeElement?.swiper;
      // swiper?.autoplay?.start();
    } else {
      console.error('Invalid slider identifier');
    }
  }

  openSignUpPopup() {
    this.referralCodeService.openSignupPopup.next(true);
  }

  getTimeAgo(dateString: string): string {
    const now = new Date().getTime();
    const past = new Date(dateString).getTime();

    const seconds = Math.floor((now - past) / 1000);

    const intervals: any = {
      year: 31536000,
      month: 2592000,
      day: 86400,
      hour: 3600,
      minute: 60
    };

    for (const key in intervals) {
      const value = Math.floor(seconds / intervals[key]);
      if (value >= 1) {
        return value + ' ' + key + (value > 1 ? 's' : '') + ' ago';
      }
    }

    return 'Just now';
  }

  get duplicatedBrandLogos() {
    return this.brandLogos?.length ? [...this.brandLogos, ...this.brandLogos] : [];
  }

  trackByLogo(index: number, record: any) {
    return record?.id ?? record?.name ?? index;
  }
}